import React from 'react';
import { useSelector } from 'react-redux';
import { useCarousel } from '../../hooks/useCarousel';
import { Link } from 'react-router-dom';
import { CRYSTAL_BACKGROUND_SVG } from '../../utils/crystalBackground';
import { useViewport } from '../../context/ViewportContext';

const HeroCarousel = () => {
  const { isMobile } = useViewport();

  // Use custom hook for carousel logic
  const {
    currentSlide,
    goToSlide
  } = useCarousel(true, 6000);
  
  // Get all slides from Redux
  const { slides } = useSelector((state) => state.frontPage);

  // Check if in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <section
      className="axl_fp_hero-carousel relative text-[#30335a]"
      style={{
        backgroundImage: `url("data:image/svg+xml;utf8,${CRYSTAL_BACKGROUND_SVG}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        /* Igor Mobile */
        height:`${isMobile && '16rem'}`,
        minHeight:`${isMobile && '16rem'}`
      }}
    >
      {/* Render ALL slides simultaneously like original */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`axl_fp_hero-slide ${
            index === currentSlide ? "active" : ""
          }`}
          style={{
            /* Igor Mobile */
            minHeight: `${isMobile && '7rem'}`,
          }}
        >
          
          <a
            key={`crslb_${index}`}
            href={slide.clink}
            target="_blank"
            rel="noopener noreferrer"
            className="axl_fp_color-block relative overflow-hidden no-underline cursor-pointer w-full"
            style={{
/*               background: `url('${isMobile ? slide.image : slide.imageDesktop}') center / ${isMobile ? 'contain' : 'cover'} no-repeat`,
              borderRadius: "1.25rem",
              boxShadow: "0 12px 30px rgba(92,103,170,0.25)",
              border: "1px solid rgba(255,255,255,0.1)",
              backgroundColor: '#f5f5f5', // Adds background color for empty space when using 'contain' */

              background: `url('${isMobile ? slide.image : slide.imageDesktop}') center / ${isMobile ? 'contain' : 'cover'} no-repeat`,
              borderRadius: "1.25rem",
              boxShadow: !isMobile && "0 12px 30px rgba(92,103,170,0.25)",
              border: !isMobile && "1px solid rgba(255,255,255,0.1)",              
            }}
          >
            {/* Crystal-inspired frame decoration */}
            <div className="absolute inset-0 border-2 border-white/20 rounded-[1.25rem] pointer-events-none"></div>
            <div className="relative z-10 text-white font-mono font-bold text-lg tracking-widest drop-shadow-lg">
              {/* -- The Number of Slide */}
              {/* String(index + 1).padStart(2, "0") */}
            </div>

            {/* Testing Mode Banner - Full width transparent at bottom */}
            {false && (
              <div className="absolute bottom-0 left-0 right-0 h-16 flex items-center justify-center bg-gradient-to-t from-black/70 via-black/50 to-transparent rounded-b-[1.25rem] border-t border-white/20">
                <div className="
                w-full
                  flex
                  items-center
                  justify-center
                  gap-2
                  px-4
                  py-1
                  bg-white
                  backdrop-blur-md
                  border
                  opacity-80
                  shadow-xl
                ">
                  <span className="
                    
                    text-gray-800
                    text-sm
                    font-bold
                    tracking-wider
                    drop-shadow-lg
                    flex
                    items-center
                    gap-2
                  ">

                    {slide.imageTxt}

                  </span>
                </div>
              </div>
            )}
          </a>

          <>
  {slide.clink?.startsWith('http') ? (
    // External link - use anchor tag
    <a
      key={`crsl_${index}`}
      href={slide.clink}
      target="_blank"
      rel="noopener noreferrer"
      className='no-underline'
    >
      {/* Your content here */}
      {!isMobile && (<div className="axl_fp_text-block text-center">
        <div className="text-center max-w-md">
          <p className="text-3xl serif italic text-blue-800 leading-tight" style={{fontSize: "1.7rem", color: "#5c67aa"}}>
            "{slide.span}"
          </p>
          <div className="w-12 h-px bg-gray-300 mx-auto mt-4"></div>
        </div>
      </div>)}
    </a>
  ) : (
    // Internal link - use React Router Link
    <Link
      key={`crsl_${index}`}
      to={slide.clink}
      className='no-underline'
    >
      {/* Your content here */}
      {!isMobile && (<div className="axl_fp_text-block text-center">
        <div className="text-center max-w-md">
          <p className="text-3xl serif italic text-blue-800 leading-tight" style={{fontSize: "1.7rem", color: "#5c67aa"}}>
            "{slide.span}"
          </p>
          <div className="w-12 h-px bg-gray-300 mx-auto mt-4"></div>
        </div>
      </div>)}
    </Link>
  )}
</>
        </div>
      ))}

      {/* EXACT ORIGINAL INDICATORS - using <span> elements */}
      <div className="axl_fp_carousel-indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={
              index === currentSlide
                ? "active bg-[#5c67aa] shadow-lg"
                : "bg-gray-300"
            }
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;